// Research breakthroughs (art audit P6) — English. Merged in ./messages.ts.

export const gameResearchEn = {
  'research.breakthrough': 'A breakthrough!',
  'research.breakthrough.sub': 'Your scholars finish their work — the bonuses fade with the feat.',
} as const;
